<template>
   <div class="intro-page-section">
      <PageFrameContainer>
         <div class="intro-layout">
            <div class="header">
               <h1>{{$t('pages.main.intro.title')}}</h1>
               <h2>{{$t('pages.main.intro.text')}}</h2>
               <DownloadOrBuyPanel>
                  {{$t('pages.main.intro.downloadText')}}
               </DownloadOrBuyPanel>
            </div>
            <div class="demo-banner-container">
               <iframe class="demo-banner-animation" ref="demo-banner-animation" frameborder="0"
                       scrolling="no"></iframe>
            </div>
         </div>
      </PageFrameContainer>
   </div>
</template>

<script>
    import DownloadOrBuyPanel from "../../../components/DownloadOrBuyPanel";
    import PageFrameContainer from "../../../components/PageFrameContainer";

    export default {
        name: "IntroSection",
        components: {PageFrameContainer, DownloadOrBuyPanel},
        async mounted() {
            let animationFrame = this.$refs['demo-banner-animation'];
            let doc = animationFrame.contentWindow.document;
            let animationContent = await require('../../../assets/pages/main/animations/signage-demo/signage-demo.html');
            doc.open().write(animationContent);
            doc.close();
        }
    }
</script>

<style scoped lang="scss">
   @import "../../../theme/theme";
   $bannerW:604px;
   $bannerH:226px;
   .intro-page-section {
      padding-top: 3rem;
      background: $primary100;

      .intro-layout {
         display: grid;
         grid-template-columns: 28rem 1fr;

         .header {
            margin-bottom: 3em;
            h1 {
               color: $primaryText100;
               font-size: 2.3rem;
               font-weight: 300;
            }

            h2 {
               margin-top: 1em;
               margin-bottom: 1em;
               color: $primaryText100;
               font-size: 1.6rem;
               font-weight: 300;
            }
         }

         .demo-banner-container {
            align-self: end;
            justify-self: right;
            overflow: hidden;

            iframe {
               overflow: hidden;
            }

            $percent:1;
            margin-bottom: -22px;
            width: $bannerW*$percent;
            height: $bannerH*$percent;
            .demo-banner-animation {
               display: block;
               border: none;

               width: $bannerW;
               height: $bannerH;
               -ms-transform: scale($percent);
               -moz-transform: scale($percent);
               -o-transform: scale($percent);
               -webkit-transform: scale($percent);
               transform: scale($percent);

               -ms-transform-origin: top left;
               -moz-transform-origin: top left;
               -o-transform-origin:  top left;
               -webkit-transform-origin:  top left;
               transform-origin:  top left;
            }

         }

         @media (max-width: 60rem) {
            grid-template-columns: 1fr;
            .demo-banner-container {
               justify-self: center;
            }
         }
         @media (max-width: 30rem) {
            .demo-banner-container {
               $percent:0.55;
               margin-bottom: -13px;

               width: $bannerW*$percent;
               height: $bannerH*$percent;
               .demo-banner-animation {
                  -ms-transform: scale($percent);
                  -moz-transform: scale($percent);
                  -o-transform: scale($percent);
                  -webkit-transform: scale($percent);
                  transform: scale($percent);
               }
            }
         }
         @media (min-width: 30rem) and (max-width: 40rem) {
            .demo-banner-container {
               $percent:0.7;
               margin-bottom: -13px;

               width: $bannerW*$percent;
               height: $bannerH*$percent;
               .demo-banner-animation {
                  -ms-transform: scale($percent);
                  -moz-transform: scale($percent);
                  -o-transform: scale($percent);
                  -webkit-transform: scale($percent);
                  transform: scale($percent);
               }
            }
         }
         @media (min-width: 40rem) and (max-width: 65rem) {
            .demo-banner-container {
               $percent:0.8;
               margin-bottom: -17px;

               width: $bannerW*$percent;
               height: $bannerH*$percent;
               .demo-banner-animation {
                  -ms-transform: scale($percent);
                  -moz-transform: scale($percent);
                  -o-transform: scale($percent);
                  -webkit-transform: scale($percent);
                  transform: scale($percent);
               }
            }
         }
         @media (min-width: 65rem) and (max-width: 70rem) {
            .demo-banner-container {
               $percent:0.9;
               margin-bottom: -17px;

               width: $bannerW*$percent;
               height: $bannerH*$percent;
               .demo-banner-animation {
                  -ms-transform: scale($percent);
                  -moz-transform: scale($percent);
                  -o-transform: scale($percent);
                  -webkit-transform: scale($percent);
                  transform: scale($percent);
               }
            }
         }
      }
   }
</style>